import React, { useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./InvoiceContainer.css";
import logo from "../../assets/authlogo.png"
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { useSelector } from "react-redux";
function InvoiceContainer({trackingNumber,region,createdAt,total,subtotal,name,paymentMethod,note,address1,address2,address3,address4,phone,items,shippingAmount,block,city,street,house_number}) {
  const today = new Date();
  const options = { year: "numeric", month: "short", day: "numeric" };
  const formattedDate = today.toLocaleDateString("en-US", options);
  const { currentLocal } = useSelector((state) => state.currentLocal);

const generatePDF = () => {
  const hiddenContainer = document.createElement("div");
  hiddenContainer.style.width = "800px"; // fixed width for better scaling
  hiddenContainer.style.position = "absolute";
  hiddenContainer.style.left = "-9999px";
  hiddenContainer.style.background = "#fff"; // ensure white background
  hiddenContainer.id = "hidden-invoice";

  const tableRows = items
    ? items
        .map(
          (item) => `
      <tr class="border-bottom">
        <td class="px-4 py-3">${item.product.name_en}</td>
        <td class="px-4 py-3">${item.quantity}</td>
        <td class="px-4 py-3">${item.product?.discounted_price_egp!=0?item.product?.discounted_price_egp:item.product?.price_egp} LE</td>
      </tr>
    `
        )
        .join("")
    : "";

  hiddenContainer.innerHTML = `
    <style>
      body { margin: 0; font-family: Arial, sans-serif; }
      .container { width: 100%; padding: 20px; box-sizing: border-box; }
      .d-flex { display: flex; }
      .justify-content-between { justify-content: space-between; }
      .fw-bold { font-weight: bold; }
      .fw-normal { font-weight: normal; }
      .border { border: 1px solid #ddd; border-radius: 5px; }
      .border-top { border-top: 1px solid #ddd; }
      .border-end { border-right: 1px solid #ddd; }
      .p-4 { padding: 16px; }
      .py-4 { padding: 16px 0; }
      .px-3 { padding: 0 12px; }
      .w-50 { width: 50%; }
      .w-25 { width: 25%; }
      .w-100 { width: 100%; }
      .text-center { text-align: center; }
      .mb-0 { margin-bottom: 0; }
      .mb-1 { margin-bottom: 4px; }
      .mb-4 { margin-bottom: 16px; }
      .mt-4 { margin-top: 16px; }
      .bg-success-subtle { background-color: #e6ffe6; }
      table { border-collapse: collapse; width: 100%; table-layout: fixed; }
      th, td { text-align: left; padding: 8px; word-wrap: break-word; }
      th { background-color: #e6ffe6; font-weight: bold; }
      .border-bottom { border-bottom: 1px solid #ddd; }
    </style>
    <div class="container">
      <div class="d-flex justify-content-between">
        <div>
          <h4 class="mb-1">INVOICE</h4>
          <p class="fw-bold">Invoice Date: <span class="fw-normal">${formattedDate}</span></p>
        </div>
        <img src="${logo}" alt="Logo" style="width: 100px;" />
      </div>
      <div class="border mt-4 p-4">
        <div class="d-flex justify-content-between mb-3">
          <div>
            <p class="mb-0 fw-bold">Order: <span class="fw-normal">${trackingNumber || ""}</span></p>
            <p class="mb-0 fw-bold">Date: <span class="fw-normal">${createdAt || ""}</span></p>
          </div>
          <div class="fw-bold">${total || 0} LE</div>
        </div>
        <div class="d-flex border-top mb-5">
          <div class="w-50 border-end py-4">
            <p class="mb-0">Payment</p>
            <p class="fw-bold">${paymentMethod || ""}</p>
            <p class="mb-0">name</p>
            <p class="fw-bold">${name || ""}</p>
            <p class="mb-0">Phone</p>
            <p class="fw-bold">${phone || ""}</p>
          </div>
          <div class="w-50 py-4 px-3">
            <p class="mb-0 fw-bold">Shipping To</p>
                <span class="fw-bold">Full Address : ${address1}</span>
                <br/>
                <span class="fw-bold">note : ${note}</span>
                <p ><span class="fw-bold">Float Number :</span> ${house_number} , <span class="fw-bold">Building Number :</span> ${block} ,<span class="fw-bold"> Street : </span>${street} , <span class="fw-bold"> Region : </span>${region},<span class="fw-bold">City : </span>${city}</p>

          </div>
        </div>
        <table class="w-100 mb-4">
          <tr class="bg-success-subtle border-bottom">
            <th class="px-4 py-2">ITEM DESCRIPTION</th>
            <th class="px-4 py-2">QTY</th>
            <th class="px-4 py-2">PRICE</th>
          </tr>
          ${tableRows}
        </table>
        <div class="d-flex flex-column align-items-end mb-4">
          <div class="w-25">
            <div class="d-flex justify-content-between pt-2">
              <p>subTotal</p>
              <p>${subtotal || 0} LE</p>
            </div>
            <div class="d-flex justify-content-between pt-2">
              <p>Shipping</p>
              <p>${shippingAmount || 0} LE</p>
            </div>
            <div class="d-flex justify-content-between pt-2 border-top">
              <p>Total</p>
              <p>${total || 0} LE</p>
            </div>
          </div>
        </div>
        <p class="text-center mb-0">Thanks for the purchase.</p>
      </div>
    </div>
  `;

  document.body.appendChild(hiddenContainer);

  html2canvas(hiddenContainer, {
    scale: 2, // improves clarity
    useCORS: true, // allows logo to load properly
    logging: false,
    width: hiddenContainer.scrollWidth, // full content width
  }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("invoice.pdf");

    document.body.removeChild(hiddenContainer);
  });
};


  return (
    <div>
      <button onClick={generatePDF} 
      className="btn btn-outline-info btn-sm square-btn d-flex justify-content-center align-items-center border-0" 
      title="Download Invoice"
      
      >
      <CloudDownloadIcon
            sx={{ 
              color: '#6C757D', 
              fontSize: '1rem', 
              marginLeft: '5px',
              marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.download}
          </p>      </button>
    </div>
  );
}

export default InvoiceContainer;
